import ScoopLogo from '../../../../assets/common/ScoopLogo.svg'
import { ScoopText, ScoopButton } from '../../../../components/ui'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../../../router/routes'
import { useSelector } from 'react-redux'
import styles from './SuccessConnectionToSlack.module.scss'

const steps = [
    {
        title: 'Step 1',
        description: (
            <>
                Open your connected workspace in{' '}
                <strong>
                    <a href="slack://open" className={styles.slackLink}>
                        Slack
                    </a>
                </strong>
            </>
        ),
    },
    {
        title: ' Step 2',
        description: (
            <>
                Use Scoop Bot by mentioning <span className={styles.scoopMention}>@Scoop</span> in a
                channel or DM the app
            </>
        ),
    },
    {
        title: 'Step 3',
        description: <>Follow the prompts from there and start exploring your data 🚀</>,
    },
]

export const SuccessConnectionToSlack = ({ success = true }) => {
    const navigate = useNavigate()
    const userID = useSelector((state) => state.auth.userID)
    return (
        <div className={styles.container}>
            <img src={ScoopLogo} alt="Scoop Logo" className={styles.logo} />
            <ScoopText className={styles.title}>
                {success ? 'Successfully connected to Slack!' : 'Failed to connect to Slack!'}
            </ScoopText>
            <div className={styles.stepsContainer}>
                {success ? (
                    <>
                        {steps.map((step, index) => (
                            <div key={index} className={styles.stepCard}>
                                <div className={styles.stepBadge}>{step.title}</div>
                                <ScoopText className={styles.stepDescription}>
                                    {step.description}
                                </ScoopText>
                            </div>
                        ))}
                        <div className={styles.buttonsContainer}>
                            <ScoopButton
                                onClick={() => navigate(ROUTES.SOURCES)}
                                className={styles.button}
                            >
                                Back to Datasets
                            </ScoopButton>
                            <a href="slack://open">
                                <ScoopButton className={styles.button}>Open Slack</ScoopButton>
                            </a>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={styles.errorCard}>
                            <ScoopText className={styles.errorMessage}>
                                We couldn't connect your workspace to Slack
                            </ScoopText>
                        </div>
                        <div className={styles.buttonsContainer}>
                            {userID && (
                                <ScoopButton
                                    onClick={() => navigate(ROUTES.SOURCES)}
                                    className={styles.button}
                                >
                                    Back to Datasets
                                </ScoopButton>
                            )}
                            <ScoopButton
                                onClick={() => window.location.reload()}
                                className={styles.button}
                            >
                                Try Again
                            </ScoopButton>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}
